<template>
  <div class="explore-points-modal-container">
    <div class="explore-points-modal-container--col">
      <div id="streetview" class="explore-points-modal-top">
        <div class="valuations-images-container">
          <div v-if="svVisible">
            <div v-if="positionerror" class="msgnotfound">
              {{ $t('streeview-not-image') }}
            </div>
            <div v-if="!positionerror" class="street-view-valuations-image street-view-valuations-image--1">
              <div :id="googleStreeViewId(1)" ref="streetView1" class="googleStreeViewContainer" />
            </div>
          </div>
          <div v-else class="position-not-selected">
            {{ $t('position-not-selected') }}
          </div>
        </div>
      </div>
      <div id="explore-points-scrollcontent" class="explore-points-modal-content">
        <div id="supply_demand">
          <div class="modal-inner-title"><span class="make-bold">{{ $t('supply&demand') }}</span></div>
          <div class="modal-inner-desc">{{ $t('supply&demand-desc') }}</div>
          <stocktable v-if="stockoptions !== null" :options="stockoptions" />
          <div v-else>{{ $t('nostockdata') }}</div>
        </div>
      </div>
    </div>
    <div class="explore-points-modal-container--col">
      <scrollTabs :scroll-container="'explore-transnews-modal-data'" class="data-sidebar--scroll">
        <scrollTab v-for="section in assetinfo.sections" :key="section.title" :name="$t(section.langkey)" :target-id="section.target" />
      </scrollTabs>
      <div id="explore-transnews-modal-data" class="explore-points-modal-data">
        <table v-for="(section, indexParent) in assetinfo.sections" :id="section.target" :key="section.title" class="brains-table" aria-describedby="portfoliosections">
          <thead>
            <tr>
              <th colspan="2">{{ $t(section.langkey) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in section.values" :key="index">
              <td>{{ indexParent === 1 ? $t('portfolioview.' + item.title) : getExcelNames(item.title) }}</td>
              <td>{{ getParsedNumber(item.value, item.title) }}</td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex'
import { gmapApi } from 'gmap-vue'
import stocktable from '@/components/StockTableChart'
import scrollTabs from '@/components/designComponents/scrollTabs'
import scrollTab from '@/components/designComponents/scrollTab'
// import demomap from '@/components/ViewComponents/brainsmap/maps/DEMOmap'
import { generateStackTableOptions } from '@/utils/chartutils'
// import { Chart } from 'highcharts-vue'
import { findGeoLocations } from '@/api/location'
export default {
  name: 'EditAssetDataModalPort',
  components: { scrollTabs, scrollTab, stocktable },
  props: {
    namespaceKey: {
      type: String,
      default: ''
    },
    assetData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loadedGeoLvl: false,
      geolvl: null,
      marketevolution: { series: [] },
      timetosaleevolution: { series: [] },
      svVisible: true,
      positionerror: false,
      camaraDirection: 270,
      camaraDirection2: 90,
      stockoptions: null
    }
  },
  computed: {
    ...mapState('portfolio', {
      matchColumns: (state) => state.currentportfolio.matchColumns
    }),
    assetinfo: function() {
      const assetdata = this.datainfo.filter(item => { return !item.name.startsWith('Brains') }).map(
        item => {
          return {
            title: item.name,
            value: item.value
          }
        }
      )
      const brainsdata = this.datainfo.filter(item => { return item.name.startsWith('Brains') }).map(
        item => {
          return {
            title: item.name,
            value: item.value
          }
        }
      )
      const asset = {
        sections: [{
          title: 'Asset Data',
          langkey: 'portfolioview.AssetData',
          target: 'table-assetdata',
          values: assetdata
        },
        {
          title: 'Brains Data',
          langkey: 'portfolioview.BrainsData',
          target: 'table-brainsdata',
          values: brainsdata
        }]
      }
      return asset
    },
    google: gmapApi,
    position: function() {
      const vm = this
      const data = vm.assetData
      return {
        longitude: data.BrainsLongitude,
        latitude: data.BrainsLatitude
      }
    },
    datainfo: function() {
      const vm = this
      const resdata = []
      Object.keys(vm.assetData).forEach(key => {
        resdata.push({
          name: key,
          value: vm.assetData[key]
        })
      })
      return resdata
    }
  },
  activated() {
    console.log('activated')
    this.initView()
  },
  mounted() {
    console.log('mounted')
    this.initView()
    const vm = this
    vm.generatestockini()
  },
  methods: {
    generatestockini() {
      const vm = this
      findGeoLocations({ latitude: vm.position.latitude, longitude: vm.position.longitude })
        .then((resp) => {
          vm.generatestock(resp.data)
        })
    },
    generatestock(levels) {
      const vm = this
      let typostr = 'dataSelectors.residential'
      if (vm.assetData.BrainsTypologie === 7) {
        typostr = 'dataSelectors.retail'
      } else if (vm.assetData.BrainsTypologie === 8) {
        typostr = 'dataSelectors.office'
      } else if (vm.assetData.BrainsTypologie === 10) {
        typostr = 'dataSelectors.industrial'
      }
      // debugger
      const actlevel = levels.filter(item => { return item.level === 3 })[0]
      const objsearch = {
        actualSelection: ['dataSelectors.sale-market', typostr, 'dataSelectors.stock'],
        chart_name: 'Mercato di vendita - ' + vm.$t(typostr) + ' - Stock',
        country_idcod: 57363,
        countryid: 57363,
        geolevel: actlevel,
        latitude: vm.position.latitude,
        longitude: vm.position.longitude,
        municipality_idcod: 1238266,
        key: '',
        geolevelselected: actlevel,
        typologyid: 0,
        geolevels: levels,
        geolevelid: actlevel.id,
        chartvisid: '0',
        typologie: '0',
        upper_idcod: 57477
      }
      objsearch.typologie = vm.assetData.BrainsTypologie
      objsearch.typologyid = objsearch.typologie
      // debugger
      vm.$store
        .dispatch('charts/setchartexport', objsearch).then((response) => {
          // const countryname = vm.geolevels[0].name
          var sectioncharts = response.chartsdata.map(item => {
            return {
              name: item.charttitle,
              type: item.charttype,
              options: item.charttype !== 'stocktable' ? null : generateStackTableOptions(item, response.allseries)
            }
          })
          // debugger
          const stockdata = response.allseries.find(item => { return item.name === 'stocktable' })
          if (stockdata.data) {
            vm.stockoptions = sectioncharts[0].options
          } else {
            vm.stockoptions = null
          }
        })
        .catch((error) => {
          console.log(error)
          // debugger
        })
    },
    googleStreeViewId(id) {
      return 'googleStreetViewContainer-' + Math.floor(Date.now() * (9999 - 0)) + id
    },
    async initView() {
      this.svVisible = true
      this.positionerror = false
      if (this.position.latitude === null || this.position.longitude === null) {
        this.svVisible = false
        return
      }
      var vm = this
      var pos = { lat: this.position.latitude, lng: this.position.longitude }
      await this.$gmapApiPromiseLazy().then(() => {
        const sv = new vm.google.maps.StreetViewService()
        this.panorama = new vm.google.maps.StreetViewPanorama(document.getElementById(vm.$refs.streetView1.id))
        sv.getPanorama(
          {
            location: pos,
            radius: 50,
            source: vm.google.maps.StreetViewSource.OUTDOOR
          },
          vm.processSVData
        )
      }).catch(err => {
        this.positionerror = true
        console.error(err)
        // debugger
      })
    },
    processSVData(data, status) {
      if (status === 'OK') {
        var location = data.location
        this.panorama.setPano(location.pano)
        // debugger
        this.panorama.setPov({
          heading: this.camaraDirection,
          pitch: 0
        })
        this.panorama.setVisible(true)
      } else {
        this.positionerror = true
        console.error('Street View data not found for this location.')
      }
    },
    processSVData2(data, status) {
      if (status === 'OK') {
        var location = data.location
        this.panorama2.setPano(location.pano)
        // debugger
        this.panorama2.setPov({
          heading: this.camaraDirection2,
          pitch: 0
        })
        this.panorama2.setVisible(true)
      } else {
        console.error('Street View data not found for this location.')
      }
    },
    getExcelNames(id) {
      var matchTitle = this.matchColumns.find(f => f.brainsId === id)
      return matchTitle ? matchTitle.clientTitle : id
    },
    formatNumber(num, decimals) {
      if (num === null || num === undefined || parseFloat(num) === 0) { return '-' }
      if (decimals === null || decimals === undefined || decimals === 0) { return num.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }
      if (decimals === 1) { return num.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }
      return num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDate(date) {
      if (date === null || date === undefined || date === '' || date === '-') { return 'na' }
      function pad(s) { return (s < 10) ? '0' + s : s }
      var d = new Date(date)
      return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
    },
    getParsedNumber(data, index) {
      console.log(index)
      switch (index) {
        case 'Areas_04':
          return (this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' ' + this.$t('sqm') : data)
        case 'BrainsAsking_Var_QoQ_Em2':
        case 'BrainsAsking_Var_QoQ_TTS':
        case 'BrainsAsking_rent_Var_QoQ_Em2_month':
        case 'BrainsTransactions_Var_QoQ_Em2':
        case 'BrainsMarket_Recovery':
          return (this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' %' : data)
        case 'BrainsEm2_month_asking_rent':
          return (this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €' : data)
        case 'BrainsAvg_Time_To_Sale':
        case 'BrainsAvg_Time_To_Rent':
          return (this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' ' + this.$t('months') : data)
        case 'Areas_02':
          return (this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + this.$t('sqm') : data)
        case 'Values_01':
        case 'Values_30':
        case 'Values_31':
        case 'BrainsEm2_Asking':
        case 'BrainsEm2_Transaction':
          return (this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €' : data)
        case 'Location_14':
        case 'Location_15':
        case 'BrainsLatitude':
        case 'BrainsLongitude':
          return this.isNumeric(data) ? data.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 4 }) : data
        case 'BrainsTypologie':
          if (data === 0) {
            return this.$t('residential')
          } else if (data === 6) {
            return this.$t('retail')
          } else if (data === 7) {
            return this.$t('office')
          } else if (data === 10) {
            return this.$t('industrial')
          } else {
            return data
          }
        default:
          return data
      }
    },
    isNumeric(str) {
      if (str === null || str === undefined) return false
      return !isNaN(str) && !isNaN(parseFloat(str))
    }
  }
}
</script>

<style lang="scss" scoped>
.valuations-images-container {
  height: 450px;
  display: contents;
  padding: 10px;

  .street-view-valuations-image {
    height: 50%;
    width: 100%;
    margin-bottom: 10px;
  }
}
.explore-points-modal-container {
  width: 100%;
  height: 100%;
  display: flex;

  &--col {
    width: 50%;
    height: 100%;
    padding: 15px 10px 15px 10px;
    display: flex;
    flex-direction: column;

    .explore-points-modal-top .googleStreeViewContainer {
      height: 300px;
    }

    .explore-points-modal-quickinfo {
      height: 300px;
      display: grid;

      & div:not(.quickinfo-link) > div {

        &:first-child {
          font-weight: bold;
          margin-bottom: 7px;
        }

        &:nth-child(2) {
          font-size: 0.85em;
        }
      }

      .quickinfo-link {
        font-weight: bold;
        margin-bottom: 7px;
        grid-column: 1 / 3;
        grid-row: 1;
      }

      .quickinfo-location {
        grid-column: 1;
        grid-row: 2;
      }
      .quickinfo-fecha {
        grid-column: 2;
        grid-row: 2;
      }
      .quickinfo-vendedor {
        grid-column: 1;
        grid-row: 3;
      }
      .quickinfo-comprador {
        grid-column: 2;
        grid-row: 3;
      }
      .quickinfo-supconst {
        grid-column: 1;
        grid-row: 4;
      }
      .quickinfo-supparcela {
        grid-column: 2;
        grid-row: 4;
      }
      .quickinfo-tipo {
        grid-column: 1;
        grid-row: 5;
      }
      .quickinfo-valor {
        grid-column: 2;
        grid-row: 5;
      }
    }

    &:nth-child(2) {

      .explore-points-modal-data {
        overflow: scroll;
      }

      table {
        font-size: 13px;
        margin-bottom: 20px;
        text-align: left !important;

        tr:nth-child(n + 1) td:first-child {
          padding-left: 40px;
          vertical-align: middle;
          width: 50%;
        }
      }
    }
  }

  .modal-inner-subtitle {
    padding: 7px;
    font-size: 0.9em;

    .make-bold {
      font-weight: bold;
    }
  }

  .modal-inner-title {
    padding: 7px;
    border-bottom: 2px solid #1e3cff;

    .make-bold {
      font-weight: bold;
    }
  }
  .modal-inner-desc {
    padding: 7px;
    font-size: 0.9em;
    text-align: justify;
    line-height: 17px;
  }

  .explore-points-modal-content {
    height: calc(100vh - 370px);
    overflow: scroll;

    & > div {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }

  .mrk_map_container {
    height: 350px;
    overflow: hidden;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss" >
.explore-points-modal-chart-cont {
  height: 410px !important;
  min-height: 410px;
  margin: 10px 0 10px 0;
  transform: scale(0.9);
  border: 1px solid lightgrey;
}
.data-sidebar--scroll {
  border-top: 1px solid lightgrey !important;
  min-height: 37px;

  .brains-scroll-container {
    .brains-scroll-tabs {
      padding-top: 10px !important;
      padding-bottom: 10px !important;

      .brains-scroll-tabs--tab {
        font-size: 15px;
      }
    }
  }
}
</style>
